import { isPlatformServer } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { Location } from '@freelancer/location';
import * as Rx from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../location/location.service";
var ABTestOverrides = /** @class */ (function () {
    function ABTestOverrides(location, platformId) {
        this.location = location;
        this.platformId = platformId;
    }
    ABTestOverrides.prototype.getOverridesHeader = function () {
        var headers = new HttpHeaders();
        if (isPlatformServer(this.platformId)) {
            return Rx.of(headers);
        }
        var overrides = new URL(this.location.href).searchParams.get('overrides');
        if (overrides) {
            headers = headers.set('freelancer-abtest-overrides', overrides);
        }
        return Rx.of(headers);
    };
    ABTestOverrides.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ABTestOverrides_Factory() { return new ABTestOverrides(i0.ɵɵinject(i1.Location), i0.ɵɵinject(i0.PLATFORM_ID)); }, token: ABTestOverrides, providedIn: "root" });
    return ABTestOverrides;
}());
export { ABTestOverrides };
